export function initPlansSwitch(options = {}) {
	const { rootSelector = ".plans", switchSelector = ".plans-switch", selectorSelector = ".plans-selector", detailsSelector = ".plans-details", activeClass = "active", planAttr = "plan", autoActivateFirst = true } = options;

	const root = document.querySelector(rootSelector);
	const switchEl = document.querySelector(switchSelector);
	const selectors = document.querySelectorAll(selectorSelector);
	const details = document.querySelectorAll(detailsSelector);

	if (!switchEl || !selectors.length || !details.length) return;

	function activate(planId) {
		if (!planId) return;

		selectors.forEach((btn) => {
			btn.classList.toggle(activeClass, btn.dataset[planAttr] === planId);
		});

		details.forEach((panel) => {
			panel.classList.toggle(activeClass, panel.dataset[planAttr] === planId);
		});

		switchEl.dataset[planAttr] = planId;
	}

	function onClick(e) {
		const btn = e.target.closest(selectorSelector);
		if (!btn) return;

		e.preventDefault();
		activate(btn.dataset[planAttr]);
	}

	if (autoActivateFirst) {
		const activeBtn = document.querySelector(`${selectorSelector}.${activeClass}`);
		const firstPlanId = (activeBtn || selectors[0]).dataset[planAttr];

		if (firstPlanId) activate(firstPlanId);
	}

	document.addEventListener("click", onClick);

	return () => {
		document.removeEventListener("click", onClick);
	};
}
